import gql from "graphql-tag";

const EDIT_RD_MUTATION = gql` 
mutation UpdateRD($rd:RegionalDirectorInput!) {
  updateRegionalDirector(rdData:$rd) {
    id
    name
    phone
    lookup_id
    first_name
    last_name
    group
    event_coordinator
    event_coordinator_email
    warehouse
  }
}
`;
export default EDIT_RD_MUTATION;